import { render, staticRenderFns } from "./ExpiredRequestEmail.vue?vue&type=template&id=232e72fa&scoped=true&"
import script from "./ExpiredRequestEmail.vue?vue&type=script&lang=js&"
export * from "./ExpiredRequestEmail.vue?vue&type=script&lang=js&"
import style0 from "./ExpiredRequestEmail.vue?vue&type=style&index=0&id=232e72fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232e72fa",
  null
  
)

export default component.exports